export const FreeResponseIcon =
	'https://resources-cdn.mission.io/public/question-library/free-response.png'
export const MultipleChoiceIcon =
	'https://resources-cdn.mission.io/public/question-library/multiple-choice.png'
export const ClozeDropdownIcon =
	'https://resources-cdn.mission.io/public/question-library/cloze-dropdown.png'
export const MultiSelectIcon =
	'https://resources-cdn.mission.io/public/question-library/multi-select.png'
export const ModelingIcon =
	'https://resources-cdn.mission.io/public/question-library/image-labeling.png'
export const Thumbnail =
	'https://resources-cdn.mission.io/public/question-library/thumbnail-icon.png'
export const ThumbnailSuccess =
	'https://resources-cdn.mission.io/public/question-library/thumbnail-icon--success.png'
export const ThumbnailDisabled =
	'https://resources-cdn.mission.io/public/question-library/thumbnail-icon--disabled.png'
